
import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const SatelliteOverlayControls = ({
  isLoadingGrid,
  showGridOverlay,
  gridDataType,
  toggleGridOverlay,
  sliderTicks,
  sliderIndex,
  gridResolution,
  setGridResolution,
  debouncedFetchGridData,
  gridData,
  t,
  isSSTAvailable,
  mapRef
}) => {
  return (
    <div className="absolute top-4 left-4 z-40">
      <DropdownButton
        id="satellite-overlay-dropdown"
        title={
          <>
            {isLoadingGrid && <span className="spinner-border spinner-border-sm me-2"></span>}
            {isLoadingGrid
              ? t('map_page.controls.loading')
              : showGridOverlay
                ? `${gridDataType === 'sst' ? t('map_page.satellite.temperature_grid') : t('map_page.satellite.chlorophyll_grid')}`
                : t('map_page.satellite.satellite_data')
            }
          </>
        }
        variant={showGridOverlay ? "success" : "light"}
        size="sm"
        className="shadow-lg"
      >
        <Dropdown.Header>{t('map_page.satellite.satellite_data')} {t('map_page.satellite.layers')}</Dropdown.Header>

        {isSSTAvailable() ? (
          <Dropdown.Item
            onClick={() => toggleGridOverlay('sst')}
            className={showGridOverlay && gridDataType === 'sst' ? 'active' : ''}
          >
            <span className="text-danger">●</span> {t('map_page.satellite.sea_surface_temperature')}
            {isLoadingGrid && gridDataType === 'sst' && <span className="ms-2 spinner-border spinner-border-sm"></span>}
          </Dropdown.Item>
        ) : (
          <Dropdown.Item disabled>
            <span className="text-muted">●</span> {t('map_page.satellite.sea_surface_temperature')}
          </Dropdown.Item>
        )}

        <Dropdown.Item
          onClick={() => toggleGridOverlay('chlorophyll')}
          className={showGridOverlay && gridDataType === 'chlorophyll' ? 'active' : ''}
        >
          <span className="text-success">●</span> {t('map_page.satellite.chlorophyll_concentration')}
          {isLoadingGrid && gridDataType === 'chlorophyll' && <span className="ms-2 spinner-border spinner-border-sm"></span>}
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.ItemText>
          <div className="px-2 py-1">
            <small className="text-muted d-block mb-2">
              <strong>{t('map_page.satellite.current_date')}:</strong> {sliderTicks[sliderIndex]?.start || t('map_page.controls.loading')}
              {sliderTicks[sliderIndex]?.end && sliderTicks[sliderIndex]?.end !== sliderTicks[sliderIndex]?.start &&
                ` ${t('map_page.satellite.to')} ${sliderTicks[sliderIndex]?.end}`
              }
            </small>

            <small className="text-muted d-block mb-2">
              {t('map_page.satellite.grid_resolution')}: {gridResolution}°
              <span className="badge bg-secondary ms-1">
                {gridResolution <= 0.05 ? '~16K+ cells' :
                 gridResolution <= 0.1  ? '~1K-4K cells' :
                 gridResolution <= 0.3  ? '~100-500 cells' :
                                           '~50-100 cells'}
              </span>
              <br />
              <span style={{ fontSize: '0.7rem' }}>
                {t('map_page.satellite.resolution_hint')}
              </span>
              {gridResolution <= 0.05 && (
                <>
                  <br />
                  <span style={{ fontSize: '0.6rem', color: '#dc3545' }}>
                    ⚠️ {t('map_page.satellite.ultra_warning')}
                  </span>
                </>
              )}
            </small>

            <input
              type="range"
              className="form-range"
              min="0.025"
              max="1.0"
              step="0.025"
              value={gridResolution}
              onChange={(e) => {
                const newResolution = parseFloat(e.target.value);
                setGridResolution(newResolution);
                debouncedFetchGridData(gridDataType, 200);
              }}
              onClick={(e) => e.stopPropagation()}
            />
            <div className="d-flex justify-content-between">
              <small style={{ fontSize: '0.6rem' }} className="text-muted">0.025° ({t('map_page.satellite.ultra')})</small>
              <small style={{ fontSize: '0.6rem' }} className="text-muted">1.0° ({t('map_page.satellite.fast')})</small>
            </div>
          </div>
        </Dropdown.ItemText>

        <Dropdown.Divider />

        <Dropdown.Item
          onClick={() => {
            // identical hide logic
            if (mapRef.current?.getLayer('satellite-grid')) {
              mapRef.current.setLayoutProperty('satellite-grid-background', 'visibility', 'none');
              mapRef.current.setLayoutProperty('satellite-no-data-pattern', 'visibility', 'none');
              mapRef.current.setLayoutProperty('satellite-grid', 'visibility', 'none');
              mapRef.current.setLayoutProperty('satellite-grid-borders', 'visibility', 'none');
            }
            // also flip state via provided API
            if (showGridOverlay) toggleGridOverlay(gridDataType);
          }}
          disabled={!showGridOverlay}
        >
          {t('map_page.satellite.hide_overlay')}
        </Dropdown.Item>

        {showGridOverlay && gridData && (
          <>
            <Dropdown.Divider />
            <Dropdown.ItemText>
              <small className="text-muted">
                {t('map_page.satellite.grid')}: {gridData.metadata?.grid_size || 0} {t('map_page.satellite.cells')}
              </small>
            </Dropdown.ItemText>
          </>
        )}
      </DropdownButton>
    </div>
  );
};

export default SatelliteOverlayControls;
